import React, { useContext } from 'react';
import { LangContext } from '../../contexts/langContext';

/**
 * Compact МУЖ / ЖЕН toggle for jyotish pair compatibility.
 */
export function JyotishGenderToggle({ gender = null, onChange, className = '' }) {
  const { $ui } = useContext(LangContext);

  return (
    <div
      className={`x_jyotish_gender_toggle${className ? ` ${className}` : ''}`}
      role="group"
      aria-label="gender"
    >
      <button
        type="button"
        className={`x_jyotish_gender_btn${gender === 'm' ? ' active' : ''}`}
        onClick={() => onChange?.('m')}
      >
        {$ui('jyotish_gender_m')}
      </button>
      <button
        type="button"
        className={`x_jyotish_gender_btn${gender === 'f' ? ' active' : ''}`}
        onClick={() => onChange?.('f')}
      >
        {$ui('jyotish_gender_f')}
      </button>
    </div>
  );
}
